import React from "react";
import BaseDialog from "./BaseDialog";
import Textarea from "../../form_components/Textarea";

export default class NewSystemAnnotationDialog extends BaseDialog {
    /**
     * Dialog for adding a new system annotation for dialog editor
     * @module NewSystemAnnotationDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.state = {
            text: ""
        };
    }

    setConfig(key, value) {
        this.setState({
            [key]: value
        });
    }

    getConfig(key) {
        return this.state[key];
    }

    /**
     * Handle add to module event
     * @param event
     */
    handleAdd(event) {
        if (!this.state.text) {
            window.apm.popupMessage("Text cannot be empty");
            return;
        }
        document.dispatchEvent(new CustomEvent("ev-dialog-node-add", {detail: {
            node: {
                text: this.state.text
            },
            type: "system"
        }}));
        w2popup.close();
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            <Textarea label="Text" value={this.state.text} context={this} valKey={"text"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}